import fetchOffers from './offersFetchActions';
import resetOffers from './resetOffers';

export default {
  fetchOffers,
  resetOffers,
};
